import { create } from 'zustand';
import type { TripStopLocation } from 'contracts/transport-routes';

type FormValues = Partial<{
  origin_uf: string;
  origin_ibge: string;
  destination_uf: string;
  destination_ibge: string;
}>

type Coordinates = Partial<{
  origin_lat: string;
  origin_lng: string;
  destination_lat: string;
  destination_lng: string;
}>

type State = {
  backwardTripFormValues: FormValues;
  backwardTripCoordinates: Coordinates;
  backwardTripStopLocations: TripStopLocation[];
}

type Actions = {
  updateBackwardTripFormValues: (formValues: FormValues) => void;
  updateBackwardTripCoordinates: (coordinates: Coordinates) => void;
  updateBackwardTripStopLocations: (stopLocations: TripStopLocation[]) => void;
  clearBackwardTripState: () => void;
}

const getInitialState = (): State => ({
  backwardTripFormValues: {},
  backwardTripCoordinates: {},
  backwardTripStopLocations: [],
});

export const useBackwardTripState = create<State & Actions>(
  (set, get) => ({
    ...getInitialState(),
    updateBackwardTripFormValues: (updatedFormValues) => set({
      backwardTripFormValues: {
        ...get().backwardTripFormValues,
        ...updatedFormValues,
      },
    }),
    updateBackwardTripCoordinates: (coordinates) => set({
      backwardTripCoordinates: {
        ...get().backwardTripCoordinates,
        ...coordinates,
      },
    }),
    updateBackwardTripStopLocations: (stopLocations) => set({
      backwardTripStopLocations: stopLocations,
    }),
    clearBackwardTripState: () => set(getInitialState()),
  }),
);